export const ARCHIVE_UNARCHIVE_LICENSE = 'mac/ARCHIVE_UNARCHIVE_LICENSE';
export const RESET_ARCHIVE_UNARCHIVE_LICENSE = 'mac/RESET_ARCHIVE_UNARCHIVE_LICENSE';
export const DEVELOPER_LICENSE = 'mac/DEVELOPER_LICENSE';
export const CLEAR_DEVELOPER_LICENSE = 'mac/CLEAR_DEVELOPER_LICENSE';
export const LICENSE_DETAILS = 'mac/FETCH_LICENSE_DETAILS';
